module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "Mintbase_logo.31d928c3.svg";